import { render, staticRenderFns } from "./publicityRegistration.vue?vue&type=template&id=2ad7e6e8&scoped=true&"
import script from "./publicityRegistration.vue?vue&type=script&lang=js&"
export * from "./publicityRegistration.vue?vue&type=script&lang=js&"
import style0 from "./publicityRegistration.vue?vue&type=style&index=0&lang=css&"
import style1 from "./publicityRegistration.vue?vue&type=style&index=1&id=2ad7e6e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad7e6e8",
  null
  
)

export default component.exports